
import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import UserCompaniesMixin from '@/mixins/UserCompaniesMixin.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import SaveButton from '@/components/SaveButton.vue'
import LabeledValue from '@/components/LabeledValue.vue'
import ProductSelector from '@/components/Order/ProductSelector.vue'
import {
  FavoriteList,
  FavoriteListCollection,
  IVendorPriceListEntry,
  PriceList,
  ReminderCollection
} from '@/firestore'
import store, { Actions } from '../../../store'
import PriceListSelector from '@/components/Order/PriceListSelector.vue'
import QuantityComboBox from '@/components/QuantityComboBox.vue'
import CategorySelectionModal from '@/components/Order/CategorySelectionModal.vue'

@Component({
  components: {
    SaveButton,
    LoadingPage,
    LabeledValue,
    ProductSelector,
    QuantityComboBox,
    PriceListSelector,
    CategorySelectionModal
  }
})
export default class FavoriteListDetail extends Mixins(IconsMixin, AuthMixin, UserCompaniesMixin) {
  public isLoading: boolean = false
  public favoriteList: FavoriteList | null = null
  public priceLists: PriceList[] = []

  // Filter Props
  public categoryFilter: string[] = []
  public categories: string[] = [
    'Beer',
    'Cocktail Mixes',
    'Hard Cider',
    'Bitters',
    'Wine',
    'Liquor & Spirits',
    'Whiskey',
    'Shochu & Soju',
    'Gin',
    'Brandy',
    'Liqueurs',
    'Vodka',
    'Absinthe',
    'Tequila',
    'Rum',
    'Flavored Alcoholic Beverages'
  ]
  public vendorFilter: { vendorCompanyId: string, vendorCompanyName: string }[] = []
  public vendorCompanyNames: { vendorCompanyId: string, vendorCompanyName: string }[] = []

  public search = ''
  public headers = [
    {text: '', sortable: false, value: 'icon'},
    {text: 'Description', value: 'description'},
    {text: 'Category', value: 'category'},
    {text: 'Vendor', value: 'vendor'},
    {text: 'Reminder', value: 'reminder'}
  ]

  public reminderMap: { [entryIdAndVendorId: string]: string[] } = {['']: ['']}
  public companyNamesMap: { [entryIdAndVendorId: string]: string } = {['']: ''}

  public $refs!: {
    form: HTMLFormElement
  }

  public get displayedEntries(): IVendorPriceListEntry[] {
    if (
        !this.favoriteList
        || !this.favoriteList.entries
        || !this.favoriteList.entries.length
    ) {
      return []
    }

    let entries = this.favoriteList.entries

    if (this.categoryFilter && this.categoryFilter.length) {
      entries = entries.filter(entry =>
          this.categoryFilter.includes(this.getCategory(entry))
      )
    }

    if (this.vendorFilter && this.vendorFilter.length) {
      entries = entries.filter(entry =>
          this.vendorFilter.find(e => e.vendorCompanyId === entry.vendorCompanyId)
      )
    }

    return entries
  }

  //METHODS
  public async mounted() {
    this.isLoading = true
    try {
      let favoriteList = await this.lookupFavoriteList()
      if (!favoriteList) {
        favoriteList = new FavoriteList(this.userCompany.id)
      }

      this.favoriteList = favoriteList
      this.displayedEntries.forEach(entry => {
        if (entry.vendorCompanyName) {
          this.vendorCompanyNames.push(
              {vendorCompanyId: entry.vendorCompanyId, vendorCompanyName: entry.vendorCompanyName}
          )
        }
      })

      await this.setReminders()
    } catch (error) {
      const err = new Error('You do not have permissions to view that page')
      return store.dispatch(Actions.SET_ERROR, [err, this.$router])
    }
    this.isLoading = false
  }

  public getCategory(entry: IVendorPriceListEntry) {
    if (!entry || !entry.category) {
      return 'N/A'
    }

    const lineageArray = entry.category.split(' > ')
    return lineageArray[lineageArray.length - 1].trim()
  }

  public getReminders(reminders: string[]) {
    if (!reminders || !reminders.length) {
      return 'N/A'
    }

    const remindersString = reminders.reduce((acc, reminder) => {
      if (!reminder || !reminder.length) {
        return acc
      } else if (!acc || !acc.length) {
        return reminder
      } else {
        return `${acc}, ${reminder}`
      }
    }, '')
    return remindersString
  }

  private async setReminders() {
    const reminderCollection = new ReminderCollection((await this.$firebase).firestore())
    const reminders = await reminderCollection.listRemindersByRestaurantCompanyId(this.userCompany.id)
    reminders.forEach(reminder => {
      if (
          this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId]
          && !this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId].includes(reminder.text)
      ) {
        this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId].push(reminder.text)
      } else if (!this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId]) {
        this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId] = [reminder.text]
      }
    })
  }

  private async lookupFavoriteList() {
    const favoriteListCollection = new FavoriteListCollection((await this.$firebase).firestore())
    return await favoriteListCollection.findFavoriteListByRestaurant(this.userCompany.id)
  }
}

